import { render, staticRenderFns } from "./Brochure.vue?vue&type=template&id=673ace68"
import script from "./Brochure.vue?vue&type=script&lang=js"
export * from "./Brochure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports